import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  id: "overview-list-detail",
  class: "body"
}
const _hoisted_2 = { class: "body__header" }
const _hoisted_3 = { class: "body__header__desc" }
const _hoisted_4 = { class: "body__header__title" }
const _hoisted_5 = { class: "body__header__title--text" }
const _hoisted_6 = { class: "body__header__desc" }
const _hoisted_7 = { class: "body__header__ym" }
const _hoisted_8 = { class: "body__graph" }
const _hoisted_9 = { class: "card__container" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "card__title" }
const _hoisted_12 = { class: "card__achievement" }
const _hoisted_13 = { class: "card__date" }

import { i18n } from '@/i18n';
import { InventoryDashboardViewModel } from '../inventoryDashboardViewModel';
import InventoryDashboardChildLayout from '../InventoryDashboardChildLayout.vue';
import KpiAchievementChart from '@/inventoryDashboardModule/components/chart/KpiAchievementChart.vue';
import { useInventoryDashboardStore } from '../useInventoryDashboardStore';
import { storeToRefs } from 'pinia';
import { computed, onBeforeUnmount, onMounted, ref } from 'vue';
import { DimensionType, DimensionTypes, MetricType, MetricTypes } from '@/inventoryDashboardModule/domains/entities/Dashboard';
import { DateService } from '@/coreDomainsModule/services/dateService';
import { UNASSIGNED_COLUMN } from '@/coreDomainsModule/constants';
import Mdi from '@/corePagesModule/components/Mdi.vue';
import { waitLoading } from '@/corePagesModule/components/InfoModal/waitLoading';
import { IYearMonth } from '@/coreDomainsModule/date';
import MonthPicker from '@/corePagesModule/components/MonthPicker.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'OverviewGraphDetailPage',
  setup(__props) {

const t = i18n.t;
const store = useInventoryDashboardStore();
const { state } = storeToRefs(store);
const { getByDimensionData } = store;

const chartComponentRef = ref<InstanceType<typeof KpiAchievementChart> | null>(null);

const beforeValues = ref<{
  metricType: MetricType;
  dimensionType: DimensionType;
  displayYearMonthPeriod: [IYearMonth, IYearMonth];
}>({
  metricType: state.value.information.metricType,
  dimensionType: state.value.information.dimensionType,
  displayYearMonthPeriod: [
    DateService.getShiftedIYearMonthFromNowDateByMonths(-12),
    DateService.getShiftedIYearMonthFromNowDateByMonths(6),
  ],
});

const latestAchievementInfos = computed(() => {
  return state.value.information.dimensionValueGroups.map((dimensionValueGroup) => {
    const latestConfirmed = dimensionValueGroup.amounts.reduce((acc, a) =>
      a.salesResult && DateService.compareYearMonths(a.yearMonth, acc.yearMonth) === 1 ? a : acc
    );
    const targetDate = DateService.convertIYearMonthToLastDateIDate(latestConfirmed.yearMonth);
    const targetKpi = dimensionValueGroup.kpi.find(
      (k) =>
        (!k.valid_from || DateService.compareDates(k.valid_from, targetDate) !== 1) &&
        (!k.valid_to || DateService.compareDates(k.valid_to, targetDate) !== -1)
    );
    return {
      name: dimensionValueGroup.dimensionValues.name || t(UNASSIGNED_COLUMN),
      yearMonth: latestConfirmed.turnover && targetKpi ? DateService.convertIYearMonthToYYYYMMWithSlash(latestConfirmed.yearMonth) : '--',
      value: latestConfirmed.turnover && targetKpi ? `${((targetKpi.kpiValue / latestConfirmed.turnover) * 100).toFixed(1)}% ` : '--',
    };
  });
});

/**
 * カードをクリックしてグラフの表示非表示を切り替えるハンドラ
 * @param index - カードのindex
 */
const onClickCard = (index: number) => {
  chartComponentRef.value?.toggleDataset(index);
};

/**
 * 表示期間を変更した際のハンドラ
 * @param start - 開始年月
 * @param end - 終了年月
 */
const onChangeYearMonthPeriod = async (start?: IYearMonth, end?: IYearMonth) => {
  if (start) {
    state.value.displayYearMonthPeriod[0] = start;
  }
  if (end) {
    state.value.displayYearMonthPeriod[1] = end;
  }
  await getByDimensionData();
};

onMounted(async () => {
  beforeValues.value = {
    metricType: state.value.information.metricType,
    dimensionType: state.value.information.dimensionType,
    displayYearMonthPeriod: state.value.displayYearMonthPeriod,
  };
  state.value.information.metricType = MetricTypes.Turnover;
  state.value.information.dimensionType = DimensionTypes.AggregateBusinessResponsibleUser;
  state.value.displayYearMonthPeriod = [
    DateService.getShiftedIYearMonthFromNowDateByMonths(-12),
    DateService.getShiftedIYearMonthFromNowDateByMonths(6),
  ];
  await waitLoading(getByDimensionData(), undefined, '');
});

onBeforeUnmount(() => {
  state.value.information.metricType = beforeValues.value.metricType;
  state.value.information.dimensionType = beforeValues.value.dimensionType;
  state.value.displayYearMonthPeriod = beforeValues.value.displayYearMonthPeriod;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(InventoryDashboardChildLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(t)('担当者別KPI達成率推移')), 1)
            ]),
            _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(t)('各担当者の在庫回転率KPI達成率の月次推移を表示しています')), 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createTextVNode(_toDisplayString(_unref(t)('表示期間')) + " ", 1),
            _createVNode(MonthPicker, {
              "model-value": _unref(state).displayYearMonthPeriod[0],
              locale: _unref(i18n).locale,
              "prop-format": _unref(t)('MonthPickerFormat'),
              class: "month-picker",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = (value) => onChangeYearMonthPeriod(value, undefined))
            }, null, 8, ["model-value", "locale", "prop-format"]),
            _cache[2] || (_cache[2] = _createElementVNode("span", { class: "body__header__ym-divide" }, "~", -1)),
            _createVNode(MonthPicker, {
              "model-value": _unref(state).displayYearMonthPeriod[1],
              locale: _unref(i18n).locale,
              "prop-format": _unref(t)('MonthPickerFormat'),
              class: "month-picker",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = (value) => onChangeYearMonthPeriod(undefined, value))
            }, null, 8, ["model-value", "locale", "prop-format"])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(KpiAchievementChart, {
            ref_key: "chartComponentRef",
            ref: chartComponentRef,
            "dimension-value-groups": _unref(state).information.dimensionValueGroups,
            "from-year-month": _unref(state).displayYearMonthPeriod[0],
            "to-year-month": _unref(state).displayYearMonthPeriod[1]
          }, null, 8, ["dimension-value-groups", "from-year-month", "to-year-month"])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(latestAchievementInfos.value, (latestAchievementInfo, index) => {
          return (_openBlock(), _createElementBlock("button", {
            key: index,
            class: "card",
            onClick: () => onClickCard(index)
          }, [
            (!chartComponentRef.value?.isDatasetVisible(index))
              ? (_openBlock(), _createBlock(Mdi, {
                  key: 0,
                  icon: "visibility_off",
                  class: "card__icon"
                }))
              : (_openBlock(), _createBlock(Mdi, {
                  key: 1,
                  icon: "visibility",
                  class: "card__icon"
                })),
            _createElementVNode("div", _hoisted_11, _toDisplayString(latestAchievementInfo.name || _unref(t)(_unref(UNASSIGNED_COLUMN))), 1),
            _createElementVNode("div", _hoisted_12, _toDisplayString(latestAchievementInfo.value), 1),
            _createElementVNode("div", _hoisted_13, _toDisplayString(latestAchievementInfo.yearMonth), 1)
          ], 8, _hoisted_10))
        }), 128))
      ])
    ], undefined, true),
    _: 1
  }))
}
}

})